import React, { useState } from "react";
import YouTubeIcon from "@material-ui/icons/YouTube";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import SpotifyIcon from "@material-ui/icons/MusicNote";
import ImageIcon from "@material-ui/icons/Image";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import api from "../../services/api";
import { Spinner } from "../../components";
import { cdn } from "../../helpers/variables";

export const InsertMedia = () => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");

  const Tag = () => {
    switch (type) {
      case "youtube":
        return <YoutubeTags />;
      case "instagram":
        return <InstagramTag />;
      case "image":
        return <ImageTag />;
      case "twitter":
        return <TwitterTag />;
      case "spotify":
        return <SpotifyTag />;
      default:
        return <span />;
    }
  };

  const ImageTag = () => {
    const [image, setImage] = useState(false);
    const [err, setErr] = useState(null);
    const [altImage, setAltImage] = useState(false);
    const [tag, setTag] = useState();
    const [loading, setLoading] = useState(false);

    const startUpload = async () => {
      setLoading(true);

      try {

        const axiosForm = new FormData();

        axiosForm.append("file", image);

        try {
          const response = await api.post(
            `/upload/uploads`,
            axiosForm
          );

          const { name, date, width, height } = response.data.content;

          const baseUrlImage = `${cdn}/images/uploads/${date}`;

          const defaultImageUrl = `${baseUrlImage}/${name}`;
          const smImageUrl = `${baseUrlImage}/300-${name}`;
          const lgImageUrl =  `${baseUrlImage}/lg-${name}`;

          const customTag = `
            <div class="tag-image">
                <figure>
                    <picture class="upload-image">
                        <source media="(max-width: 450px)" srcset="${smImageUrl}" />
                        <source media="(max-width: 1000px)" srcset="${lgImageUrl}" />
                        <source srcset="${defaultImageUrl}" />
                        <img loading="lazy" src="${defaultImageUrl}" alt="${altImage}" />
                    </picture>
                    <figcaption>${altImage}</figcaption>
                </figure>
            </div>
            <div class="tag-image-amp">
                <figure>
                    <div>
                    <amp-img
                        alt="${altImage}"
                        src="${defaultImageUrl}"
                        width="${width}"
                        height="${height}"
                        layout="responsive"
                        srcset="${defaultImageUrl} 2000w, ${lgImageUrl} 1080w, ${smImageUrl} 550w"
                        >
                    </amp-img>
                    </div>
                    <figcaption>
                      ${altImage}
                    </figcaption>
                </figure>
            </div> `;
          
          setTag(customTag);
          setLoading(false);
          setImage(null);
          setAltImage(null);

        } catch ({ response }) {
          const { data } = response;

          console.log("response image error", data);

          setErr(data.code);
          setLoading(false);
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    const handleUploadImage = (e) => {
      setErr(null);
      setImage(e.target.files[0]);
    };

    const handleLegImage = (e) => {
      setErr(null);
      setAltImage(e.target.value.replace(/"/g, "'"));
    };

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <li>
          <form noValidate autoComplete="off">
            <input
              accept="image/*"
              id="upload-image"
              multiple
              type="file"
              onChange={handleUploadImage}
            />
            <TextField
              disabled={!image}
              onChange={handleLegImage}
              placeholder="Informe uma descrição para a imagem"
              style={{ minWidth: "450px", margin: "20px 0" }}
            />
          </form>
        </li>
        {tag && (
          <textarea style={{ width: "100%" }} rows="5">
            {tag}
          </textarea>
        )}
        {err && <span>{err}</span>}
        <li style={{ marginTop: "10px" }}>
          {loading ? (
            <Spinner />
          ) : (
            <Button
              variant="contained"
              onClick={startUpload}
              disabled={!altImage}
              color="primary"
            >
              Upload
            </Button>
          )}
        </li>
      </div>
    );
  };

  const TwitterTag = () => {
    const [tag, setTag] = useState("");
    const [twitter, setTwitter] = useState();

    const getTags = () => {
      const el = document.createElement("div");
      el.innerHTML = twitter;

      console.log("el???", el.getElementsByTagName("a"));

      let id;

      const links = [...el.getElementsByTagName("a")];

      links.forEach((link) => {
        const linkSplited = link.pathname.split("/");

        console.log("linkSplited", linkSplited);

        if (linkSplited[2] === "status") {
          id = linkSplited[3];
        }
      });

      console.log("id <<><>", id);

      const customTag = `
                <div class="tag-twitter">
                    ${
                      twitter.split(
                        '<script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>'
                      )[0]
                    }
                </div>
                <div class="tag-twitter-amp">
                    <amp-twitter
                        width="375"
                        height="472"
                        layout="responsive"
                        data-tweetid="${id}"
                    >
                    </amp-twitter>
                </div>    
            `;

      setTag(customTag);
    };

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <li>
          <TextField
            onChange={(e) => setTwitter(e.target.value)}
            value={twitter}
            placeholder="Informe o cod embed do twitter"
            style={{ minWidth: "450px", marginBottom: "10px" }}
          />
        </li>
        {tag && (
          <li
            style={{
              margin: "20px 0",
              width: "100%",
              backgroundColor: "#f7f7f7",
              padding: "12px",
            }}
          >
            {" "}
            {tag}{" "}
          </li>
        )}
        <li>
          <Button
            variant="contained"
            onClick={getTags}
            disabled={!twitter}
            color="primary"
          >
            Gerar tag
          </Button>
        </li>
      </div>
    );
  };

  const SpotifyTag = () => {
    const [url, setUrl] = useState();
    const [tag, setTag] = useState();

    const getTags = () => {
      const [, path] = url.split("https://open.spotify.com/");

      const customTag = `
                <div class="tag-spotify">
                    <iframe loading="lazy" width="400" height="600" src="https://open.spotify.com/embed/${path}" frameborder="0"></iframe>
                </div>
                <div class="tag-spotify-amp">
                    <amp-iframe
                        sandbox="allow-scripts allow-same-origin"
                        layout="responsive"
                        frameborder="0"
                        width="300"
                        height="300"
                        src="https://open.spotify.com/embed/${path}">
                </amp-iframe>
                </div> `;

      setTag(customTag);
    };

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <li>
          <TextField
            onChange={(e) => setUrl(e.target.value)}
            value={url}
            placeholder="ex: https://open.spotify.com/album/6UR0x7bNfO46BNsRiXXSlQ"
            style={{ minWidth: "450px", marginBottom: "10px" }}
          />
        </li>
        {tag && (
          <li
            style={{
              margin: "20px 0",
              width: "100%",
              backgroundColor: "#f7f7f7",
              padding: "12px",
            }}
          >
            {" "}
            {tag}{" "}
          </li>
        )}
        <li>
          <Button
            variant="contained"
            onClick={getTags}
            disabled={!url}
            color="primary"
          >
            Gerar tag
          </Button>
        </li>
      </div>
    );
  };

  const InstagramTag = () => {
    const [urlInsta, setUrlInsta] = useState();
    const [tag, setTag] = useState();

    const getTags = () => {
      const cod = urlInsta.split("/")[4];

      console.log("cod", cod);

      const customTag = `
            <div class="tag-instagram">
                <iframe loading="lazy" width="400" height="600" src="https://instagram.com/p/${cod}/embed" frameborder="0"></iframe>
            </div>
            <div class="tag-youtube-amp">
                <amp-instagram data-shortcode="${cod}"
                    width="1"
                    height="1"
                    layout="responsive">
                </amp-instagram>
            </div> `;

      setTag(customTag);
    };

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <li>
          <TextField
            onChange={(e) => setUrlInsta(e.target.value)}
            value={urlInsta}
            placeholder="ex: https://www.instagram.com/p/B5I2Fxjg2VY/"
            style={{ minWidth: "450px", marginBottom: "10px" }}
          />
        </li>
        {tag && (
          <li
            style={{
              margin: "20px 0",
              width: "100%",
              backgroundColor: "#f7f7f7",
              padding: "12px",
            }}
          >
            {" "}
            {tag}{" "}
          </li>
        )}
        <li>
          <Button
            variant="contained"
            onClick={getTags}
            disabled={!urlInsta}
            color="primary"
          >
            Gerar tag
          </Button>
        </li>
      </div>
    );
  };

  const YoutubeTags = () => {
    const [urlYoutube, setUrlYoutube] = useState();
    const [tag, setTag] = useState();

    const getTags = () => {
      const splitV = urlYoutube.split("?v=")[1];
      const idVideoYoutube = splitV.split("&")[0];

      const customTag = `
            <div class="tag-youtube">
                <iframe loading="lazy" width="560" height="315" src="https://www.youtube.com/embed/${idVideoYoutube}" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="tag-youtube-amp">
                <amp-youtube
                    data-videoid="${idVideoYoutube}"
                    layout="responsive"
                    width="480"
                    height="270">
                </amp-youtube>
            </div> `;

      setTag(customTag);
    };

    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <li>
          <TextField
            onChange={(e) => setUrlYoutube(e.target.value)}
            value={urlYoutube}
            placeholder="ex: https://www.youtube.com/watch?v=Q0pzgw8b7PE"
            style={{ minWidth: "450px", marginBottom: "10px" }}
          />
        </li>
        {tag && (
          <li
            style={{
              margin: "20px 0",
              width: "100%",
              backgroundColor: "#f7f7f7",
              padding: "12px",
            }}
          >
            {" "}
            {tag}{" "}
          </li>
        )}
        <li>
          <Button
            variant="contained"
            onClick={getTags}
            disabled={!urlYoutube}
            color="primary"
          >
            Gerar tag
          </Button>
        </li>
      </div>
    );
  };

  const handleDialogOpen = (open, type) => {
    setOpen(open);
    setType(type);
  };

  return (
    <div className="aside-menu__insert-media">
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        onClose={() => setOpen(false)}
        open={open}
      >
        <DialogTitle id="simple-dialog-title">
          Gerar tags para {type}
        </DialogTitle>
        {type && <Tag />}
      </Dialog>
      <h3>Inserir media</h3>
      <ul>
        <li onClick={() => handleDialogOpen(true, "image")}>
          <ImageIcon color="primary" /> <span>Imagem</span>{" "}
        </li>
        <li onClick={() => handleDialogOpen(true, "youtube")}>
          <YouTubeIcon color="primary" /> <span>Youtube</span>
        </li>
        <li onClick={() => handleDialogOpen(true, "instagram")}>
          <InstagramIcon color="primary" /> <span>Instagram</span>{" "}
        </li>
        <li onClick={() => handleDialogOpen(true, "twitter")}>
          <TwitterIcon color="primary" /> <span>Twitter</span>{" "}
        </li>
        <li onClick={() => handleDialogOpen(true, "spotify")}>
          <SpotifyIcon color="primary" /> <span>Spotify</span>{" "}
        </li>
      </ul>
    </div>
  );
};
